module.exports = __webpack_public_path__ + "static/media/viber-social-media-svgrepo-com.11bcb3f8.svg";